import Link from 'next/link';
import { Plus } from 'lucide-react';
import { useTranslation } from '../../../../lib/i18n';
import { NAV_ICONS } from '../components/nav-icons';
import { useSidebarNav, type NavId } from '../hooks/use-sidebar-nav';
import { IconButton } from '../../ui';
import styles from './MobileSidebar.module.css';

// The mobile drawer's destination list — the same items as the wide rail
// (useSidebarNav), drawn as the design's flat 18px rows with no pill or hover fill.
export function MobileNav({ current, onClose }: { current?: NavId; onClose?: () => void }) {
  const { t } = useTranslation();
  const { items, newChat } = useSidebarNav({ current, onClose });
  return (
    <nav aria-label={t('nav.primary')} className={`${styles.group} ${styles.navGroup}`}>
      {items.map((item) => (
        <div key={item.id} className={styles.navRow}>
          <Link
            href={item.route}
            as={item.path}
            onClick={item.onClick}
            aria-current={item.isActive ? 'page' : undefined}
            className={styles.row}
          >
            <span aria-hidden className={styles.rowIcon}>{NAV_ICONS[item.id]}</span>
            <span className={styles.rowLabel}>{item.label}</span>
          </Link>
          {item.id === 'chats' && newChat.visible && (
            <IconButton disabled={newChat.disabled} onClick={newChat.onClick}
              aria-label={newChat.label} title={newChat.label}>
              <Plus size={16} aria-hidden />
            </IconButton>
          )}
        </div>
      ))}
    </nav>
  );
}
